'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBar = exports.CHARACTERS_BEFORE_START = exports.CLASS_VISIBLE = exports.SEARCH_RESULTS_SHOW = exports.SEARCH_RESULTS_CONTAINER = exports.SEARCH_RESULTS = exports.SEARCH_BAR_INPUT = exports.SEARCH_BAR_HIDE = exports.SEARCH_BAR_CONTAINER = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _pcSlateTools = require('@process-creative/pc-slate-tools');

var _Responsive = require('./../../settings/Responsive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Elements
var SEARCH_BAR_CONTAINER = exports.SEARCH_BAR_CONTAINER = '[data-search-bar]'; /*
                                                                                *  Search Bar Scripts
                                                                                *    Scripts for the search bar, fetches products via Ajax.
                                                                                *
                                                                                *  Version:
                                                                                *    1.0.0 - 2019/05/30
                                                                                */

var SEARCH_BAR_HIDE = exports.SEARCH_BAR_HIDE = '[data-search-hide]';
var SEARCH_BAR_INPUT = exports.SEARCH_BAR_INPUT = '[data-search-input]';
var SEARCH_RESULTS = exports.SEARCH_RESULTS = '[data-search-results]';
var SEARCH_RESULTS_CONTAINER = exports.SEARCH_RESULTS_CONTAINER = '[data-search-results-container]';

var SELECTOR_MOBILE_MENU = '[data-mobile-menu]';
var SELECTOR_HEADER_CONTAINER = '[data-header-container]';

var CLASS_HAS_SEARCH_RESULTS = 'has-search-results';
var CLASS_HAS_SKELETON_SEARCH_RESULTS = 'has-skeleton-search-results';

//Attrs
var SEARCH_RESULTS_SHOW = exports.SEARCH_RESULTS_SHOW = 'data-search-results-show';

var CLASS_VISIBLE = exports.CLASS_VISIBLE = 'is-visible';
var CLASS_SHOW_SKELETON_RESULTS = 'is-showing-skeleton-results';
var CHARACTERS_BEFORE_START = exports.CHARACTERS_BEFORE_START = 3;

var SearchBar = exports.SearchBar = function () {
  function SearchBar(container) {
    var _this = this;

    (0, _classCallCheck3.default)(this, SearchBar);


    this.searchBar = container;
    this.searchBarHide = container.find(SEARCH_BAR_HIDE);
    this.searchBarInput = container.find(SEARCH_BAR_INPUT);
    this.mobileMenu = (0, _jquery2.default)(document).find(SELECTOR_MOBILE_MENU);
    this.headerContainer = (0, _jquery2.default)(document).find(SELECTOR_HEADER_CONTAINER);
    this.containingElems = [this.mobileMenu, this.headerContainer];
    this.searchResultsContainer = container.find(SEARCH_RESULTS_CONTAINER);

    this.resultsToShow = container.attr(SEARCH_RESULTS_SHOW);

    container.on('click touchend', SEARCH_BAR_HIDE, function (e) {
      return _this.onSearchHide(e);
    });

    container.on('keyup', SEARCH_BAR_INPUT, function (e) {
      return _this.onSearchInput(e);
    });

    //Event to hide search if clicked out
    (0, _jquery2.default)(document).on('click', function (e) {
      return _this.onClickOutside(e);
    });

    (0, _jquery2.default)(window).on('resize', function () {
      _this.layout = window.innerWidth > _Responsive.large ? 'desktop' : 'mobile';
    }.bind(this));
  }

  (0, _createClass3.default)(SearchBar, [{
    key: 'cancelEvents',
    value: function cancelEvents(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch() {
      this.searchBarInput.val(null);
      this.clearResults();
    }
  }, {
    key: 'clearResults',
    value: function clearResults() {
      this.containingElems.forEach(function (elem) {
        elem.removeClass(CLASS_HAS_SEARCH_RESULTS);
        elem.removeClass(CLASS_HAS_SKELETON_SEARCH_RESULTS);
      });
      this.searchResultsContainer.removeClass(CLASS_VISIBLE);
      this.searchResultsContainer.html('');
    }
  }, {
    key: 'onSearchShow',
    value: function onSearchShow(e) {
      this.cancelEvents(e);

      this.searchBar.addClass(CLASS_VISIBLE);
      //Focus on our select box. Click required to resolve iOS bug.

      this.timer = setTimeout(function () {
        return document.querySelector(SEARCH_BAR_INPUT).focus();
      }, 250);
      // this.timer = setTimeout(() => this.searchBarInput.click().focus(), 250);
      this.searchResultsContainer.removeClass(CLASS_VISIBLE);
    }
  }, {
    key: 'onSearchHide',
    value: function onSearchHide(e) {
      this.cancelEvents(e);

      this.searchBar.removeClass(CLASS_VISIBLE);
      this.clearSearch();
    }
  }, {
    key: 'onSearchInput',
    value: function onSearchInput(e) {
      var _this2 = this;

      this.clearResults();
      var val = (0, _jquery2.default)(e.target).val();
      if (!val.length || val.length < 3 || val === '') {
        return;
      }

      //Wait half a second (if needed) before fetching ajax
      if (this.timer) clearTimeout(this.timer);
      this.showSkeletonProducts();
      this.timer = setTimeout(function () {
        return _this2.onSearch(val);
      }, 200);
    }
  }, {
    key: 'onSearch',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(val) {
        var result;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.fetching) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:

                this.fetching = true;

                val += '*';

                result = null;
                _context.prev = 5;
                _context.next = 8;
                return (0, _pcSlateTools.shopifyGet)('/search', { view: 'json', type: 'product', q: val });

              case 8:
                result = _context.sent;
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                console.error(_context.t0);

              case 14:

                this.fetching = false;

                if (result) {
                  _context.next = 25;
                  break;
                }

                if (!this.fetchAgain) {
                  _context.next = 21;
                  break;
                }

                this.fetchAgain = false;
                return _context.abrupt('return');

              case 21:
                this.fetchAgain = true;
                this.onSearch(val);

              case 23:
                _context.next = 28;
                break;

              case 25:

                this.showSkeletonProducts(false);
                this.fetchAgain = false;
                this.printSearchResults(result, val);

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function onSearch(_x) {
        return _ref.apply(this, arguments);
      }

      return onSearch;
    }()
  }, {
    key: 'showSkeletonProducts',
    value: function showSkeletonProducts() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (show) {
        this.clearResults();
        this.containingElems.forEach(function (elem) {
          elem.addClass(CLASS_HAS_SKELETON_SEARCH_RESULTS);
        });
      } else {
        this.containingElems.forEach(function (elem) {
          elem.removeClass(CLASS_HAS_SKELETON_SEARCH_RESULTS);
        });
      }
    }
  }, {
    key: 'printSearchResults',
    value: function printSearchResults(result, query) {
      //Show search results box

      this.containingElems.forEach(function (elem) {
        elem.addClass(CLASS_HAS_SEARCH_RESULTS);
      });
      var HIDDEN_PRODUCT_TAG = "product_hide";
      var validProducts = result.results.filter(function (r) {
        return !r.tags.includes(HIDDEN_PRODUCT_TAG);
      });
      var maxProductsToPrint = this.layout == 'desktop' ? 8 : 5;
      var productsToPrint = validProducts.slice(0, maxProductsToPrint);
      var searchTerms = result.terms.replace('*', '');

      //Generate results print

      var htmlToRender = !productsToPrint.length ? getNoResultsPrint() : getResultsPrint();

      this.searchResultsContainer.html(htmlToRender);

      // implementation

      function getNoResultsPrint() {
        return (/* html */'\n        <p class="c-search-bar__results-term">\n          ' + Language.strings['general.search.no_results'] + ' \'' + searchTerms + '\'\n        </p>\n      '
        );
      }

      function getResultsPrint() {

        return (/* html */'\n      \n        <div class="c-search-bar__results-title o-title">\n          ' + Language.strings['general.search.results_heading'] + '\n        </div>\n        <div class="c-search-bar__products">\n          ' + productsToPrint.reduce(function (html, product) {
            return (/* html */html + '\n              <a href="' + product.url + '" title="' + product.title + '" class="c-search-bar__product">\n                ' + (0, _pcSlateTools.generatePicture)(product.image, 300, [150], 'c-search-bar__product-image') + '\n                <div class="c-search-bar__product-details">\n                  ' + (!product.title ? '' : /* html */'\n                    <div class="c-search-bar__product-pretitle o-paragraph">\n                      ' + product.pretitle + '\n                    </div>\n                  ') + '\n                  <h6 class="c-search-bar__product-title">' + product.title + '</h6>\n                  <span\n                    class="c-search-bar__product-price"\n                    data-currency data-money="' + product.price + '"\n                  >\n                    ' + (0, _pcSlateTools.printMoney)(product.price) + '\n                  </span>\n                </div>\n              </a>\n            '
            );
          }, '') + '\n          <a \n            href="/search?type=product&q=' + query + '&type=product" \n            class="c-search-bar__view-more"\n          >\n            ' + Language.strings['general.search.view_all'] + '\n            (' + validProducts.length + ')\n          </a>\n        </div>\n      '
        );
      }
    }
  }, {
    key: 'onClickOutside',
    value: function onClickOutside(e) {
      var check = this.searchBar.find(e.target);
      if (check.length) return;
      this.clearSearch();
    }
  }]);
  return SearchBar;
}();